import type { IAvailableIcons } from './Icon'
import type { ISxProps } from './types'

import Icon from './Icon'
import { Chip as MUIChip } from '@mui/material'
export interface IChipProps {
  variant?: 'filled' | 'outlined'
  sx?: ISxProps
  label: string
  href?: string
  color?: 'default' | 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning'
  size?: 'small' | 'medium'
  icon?: IAvailableIcons
}

export default function Chip({ label, variant, sx, href, size = 'small', color, icon }: IChipProps) {
  return (
    <MUIChip
      variant={variant}
      sx={sx}
      label={label}
      clickable={!!href}
      component={href ? 'a' : 'div'}
      href={href}
      size={size}
      icon={icon && <Icon icon={icon} sx={{ fontSize: 'small', ml: 1, color }} />}
      color={color || 'secondary'}
    />
  )
}
